import LanguageSelectContainer from "../../cpq/overrides/LanguageSelectContainer/LanguageSelectContainer";
import { useEasySession } from "../../providers/easySessionProvider";
import { BtnNeedHelp } from "../BtnNeedHelp/BtnNeedHelp";

import { JSX } from "react";

import LockSharpIcon from "@mui/icons-material/LockSharp";
import { Box, Link, Typography } from "@mui/material";

export function AppHeaderUtilities(): JSX.Element {
  const { isLoggedIntoEasy, preferredName } = useEasySession();
  return (
    <Box display="flex" alignItems="center" justifyContent="flex-end" mr={1}>
      <Box display="flex" alignItems="center" gap={1}>
        <BtnNeedHelp />
        {isLoggedIntoEasy ? (
          <>
            <Typography variant="body2" display="flex" alignItems="center">
              {preferredName}
            </Typography>
          </>
        ) : (
          <Link href="/oauth2/start">
            <Typography
              variant="body2"
              display="flex"
              alignItems="center"
              sx={{ textTransform: "capitalize" }}
            >
              <LockSharpIcon fontSize="inherit" />
              Login
            </Typography>
          </Link>
        )}
        <LanguageSelectContainer />
      </Box>
      {/* <SearchBar /> */}
    </Box>
  );
}
